module.exports = __webpack_public_path__ + "static/media/luna.8d711814.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/luna.png
// module id = 193
// module chunks = 0